import { IUploadedDocuments } from 'us.collection.case/reducers/Dashboard/Interfaces'

export const UploadedDocuments: IUploadedDocuments = {
    data: [],
    isLoading: false,
    error: ""
}